import ActivityIndicator from './ActivityIndicator'
import ToDoItem from './ToDoItem'
import { useTranslation } from 'react-i18next'
import { useDrop } from 'react-dnd'
import Button from './Button'
import { UpdateTodo } from '../graphql/mutations'
import { useApolloClient, useMutation } from '@apollo/client'
import { GetTodos } from '../graphql/queries'

const ToDoColumn = ({ status, items, onItemPress, loading, onAddClick }) => {
    const { t } = useTranslation()
    const [updateTodo, { loading: updateTodoLoading }] = useMutation(UpdateTodo)
    const apolloClient = useApolloClient()

    const [{ isOver }, drop] = useDrop(
        () => ({
            accept: 'TODO_ITEM',
            drop: async (item) => {
                await updateTodo({
                    variables: {
                        id: parseInt(item.id),
                        data: {
                            STATUS: parseInt(status.value),
                        },
                    },
                })
                apolloClient.refetchQueries({
                    include: [GetTodos],
                })
            },
            collect: (monitor) => ({
                isOver: !!monitor.isOver()
            }),
        }),
        [items]
    )

    return (
        <div
            ref={drop}
            className='todos-list-column'
            style={{
                border: isOver ? '2px solid var(--primary)' : '2px solid transparent',
            }}
        >
            <div className='todos-list-column-title'>
                <span>{status.label}</span>
                {
                    status?.value !== 3 && (
                        <Button
                            label={t('Uus ülesanne')}
                            onClick={onAddClick}
                            className={'btn-small'}
                        />
                    )
                }
            </div>
            {
                loading ? (
                    <div className='todos-list-column-loading'>
                        <ActivityIndicator />
                    </div>
                )
                    : (
                        <div className='todos-list-column-items'>
                            {
                                items?.map((todo) => (
                                    <ToDoItem
                                        key={todo.ID}
                                        data={todo}
                                        onPress={() => {
                                            onItemPress && onItemPress(todo)
                                        }}
                                    />
                                ))
                            }
                        </div>
                    )
            }
        </div>
    )
}

export default ToDoColumn